import { DtoContentType, DtoExtension } from '@/shared/constants';
import type {BgmCatalogItem} from '@waka/compat/bgm-catalog';

export const BGM_DRAG_TYPE = 'application/x-editor-bgm';

export interface BgmDragData {
  itemId: number|string;
  name: string;
  publicUrl: string;
  contentType: typeof DtoContentType.audio;
  duration: number | null;
  extension: DtoExtension;
  wakaBgmSource?:BgmCatalogItem['wakaBgmSource'];
}

let currentBgmDragData: BgmDragData | null = null;

export const getCurrentBgmDragData = (): BgmDragData | null =>
  currentBgmDragData;

export const setCurrentBgmDragData = (data: BgmDragData | null): void => {
  currentBgmDragData = data;
};
